import { useQuery } from '@tanstack/react-query';

import { shouldRetryMe } from '@/hooks/use-auth-state';
import { fetchAllRevealRequests } from '@/lib/fetch-all-pages';
import { queryKeys } from '@/lib/query-keys';

// Every reveal request the current account is party to, one complete
// flat list (fetchAllRevealRequests loops the cursor pages -- some
// consumers scan for a specific pair, which must not be truncated by
// page one). Shared by the reveal-requests screen, profile-view's
// existing-request check, and the incoming-count badge, which dedupe
// into one request and refresh together for free.
//
// retry: shouldRetryMe -- a 401/403 is a dead session, deterministic
// rather than transient, so it gets no backoff; real failures retry.
export function useMyRevealRequests(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.revealRequests(),
    queryFn: fetchAllRevealRequests,
    enabled: options?.enabled,
    retry: shouldRetryMe,
  });
}
